export default "__VITE_ASSET__fbb0ea83__"